package com.rainbowclubs.rainbow.navigation

import kotlinx.serialization.Serializable
import org.jetbrains.compose.resources.StringResource
import rainbowclubs.composeapp.generated.resources.*

enum class Screen(
    val title: StringResource,
    val routeBase: String,
) {
    Splash(title = Res.string.splash_screen_name, "splash"),
    Landing(title = Res.string.landing_screen_name, "landing"),
    Signup(title = Res.string.signup_screen_name, "signup"),
    Login(title = Res.string.login_screen_name, "login"),
    SelectClub(title = Res.string.select_club_screen_name, "select_club"),
}

@Serializable
data class MembershipDataRoute(val clubId: String)

@Serializable
data class HomeRoute(val clubId: String)

@Serializable
data class AdminRoute(val clubId: String)

@Serializable
data class TakeAttendanceRoute(
    val clubId: String,
    val eventId: String? = null,
)

@Serializable
data class ManageEventsRoute(val clubId: String)

@Serializable
data class ManageClubRoute(val clubId: String)

@Serializable
data class ManageMembersRoute(
    val clubId: String,
    val role: String,
)

@Serializable
data class PendingInvitationsRoute(val clubId: String)

@Serializable
data class ExistingMembersRoute(val clubId: String)

@Serializable
data class ExistingMemberDetailsRoute(
    val clubId: String,
    val membershipId: String,
)

@Serializable
data class CreateEventRoute(val clubId: String)

@Serializable
data class EditEventRoute(val clubId: String)

@Serializable
data class UpdateEventRoute(
    val clubId: String,
    val eventId: String,
)

@Serializable
data class EventDetailsRoute(
    val clubId: String,
    val eventId: String,
)

@Serializable
data class ClubRoute(val clubId: String)

@Serializable
data class MessagesRoute(val clubId: String)

@Serializable
data class MoreRoute(val clubId: String)
